import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
const Features = () => {
  return <section id="caracteristicas" className="py-16 md:py-24 bg-white" data-id="element-78">
      <div className="container mx-auto px-4" data-id="element-79">
        <div className="max-w-3xl mx-auto" data-id="element-80">
          <h2 className="text-3xl md:text-4xl font-bold text-promred-gray mb-6" data-id="element-81">
            ¿Por qué elegir <span className="text-promred-red" data-id="element-82">Promred</span>?
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-83">
            Nos destacamos por ofrecer soluciones personalizadas y efectivas que
            generan resultados tangibles para nuestros clientes.
          </p>
          <div className="space-y-4" data-id="element-84">
            <div className="flex items-start" data-id="element-85">
              <CheckCircleIcon className="text-promred-red mr-3 mt-1 flex-shrink-0" size={20} data-id="element-86" />
              <div data-id="element-87">
                <h3 className="font-semibold text-promred-gray text-lg" data-id="element-88">
                  Experiencia comprobada
                </h3>
                <p className="text-gray-600" data-id="element-89">
                  Contamos con amplia experiencia en el desarrollo y gestión de
                  programas de fidelización y eventos.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-90">
              <CheckCircleIcon className="text-promred-red mr-3 mt-1 flex-shrink-0" size={20} data-id="element-91" />
              <div data-id="element-92">
                <h3 className="font-semibold text-promred-gray text-lg" data-id="element-93">
                  Soluciones a medida
                </h3>
                <p className="text-gray-600" data-id="element-94">
                  Adaptamos nuestras soluciones a las necesidades específicas de
                  cada cliente y sector.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-95">
              <CheckCircleIcon className="text-promred-red mr-3 mt-1 flex-shrink-0" size={20} data-id="element-96" />
              <div data-id="element-97">
                <h3 className="font-semibold text-promred-gray text-lg" data-id="element-98">
                  Tecnología avanzada
                </h3>
                <p className="text-gray-600" data-id="element-99">
                  Utilizamos las últimas tecnologías para garantizar la eficacia
                  de nuestras soluciones.
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-100">
              <CheckCircleIcon className="text-promred-red mr-3 mt-1 flex-shrink-0" size={20} data-id="element-101" />
              <div data-id="element-102">
                <h3 className="font-semibold text-promred-gray text-lg" data-id="element-103">
                  Resultados medibles
                </h3>
                <p className="text-gray-600" data-id="element-104">
                  Nos enfocamos en generar resultados tangibles y medibles para
                  nuestros clientes.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Features;